<template lang="html">
  <div class="__loading">
    <v-overlay :value="overlay" color="white">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      overlay: true,
      url_id: '',
      form: {
        item: []
      }
    }
  },
  mounted() {
    this.goToAstrapay()
  },
  methods: {
    async goToAstrapay() {
      this.$store.dispatch('set_qrmode', true)
      this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
      this.$store.dispatch('saveDataCartTakeAway', this.form)
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    }
  }
}
</script>
